'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollTo = function () {
  function ScrollTo(el) {
    (0, _classCallCheck3.default)(this, ScrollTo);

    this.el = el;
    this.key = el.dataset.scrollTo;

    this.isTicking = false;
    this.lastKnownY = 0;

    this.shouldFadeOut = this.el.dataset.shouldFadeOut !== 'false';

    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(ScrollTo, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      window.addEventListener('scroll', this.onScroll);

      this.el.addEventListener('click', function (evt) {
        evt.preventDefault();

        (0, _utils.scrollToY)(_this.getOffset(_this.key));
      });
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      this.lastKnownY = window.scrollY;

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) requestAnimationFrame(this.updateEl);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      if (this.shouldFadeOut) {
        this.el.style.opacity = this.lastKnownY >= 10 ? '0' : '';
      }
    }
  }, {
    key: 'getOffset',
    value: function getOffset(key) {
      var offset = void 0;

      if (key === 'next-section') {
        var parent = this.el.closest('[data-scroll-to-next-parent]').parentNode;
        var nextSection = parent.nextElementSibling.firstElementChild;

        var _window$getComputedSt = window.getComputedStyle(nextSection),
            marginTop = _window$getComputedSt.marginTop;

        offset = (0, _utils.getOffsetTop)(nextSection) - (0, _functional.styleToNumber)(marginTop);
      } else {
        var element = (0, _functional.getElement)('[data-scroll-to-target="' + key + '"]');

        var _window$getComputedSt2 = window.getComputedStyle(element),
            _marginTop = _window$getComputedSt2.marginTop;

        offset = (0, _utils.getOffsetTop)(element) - (0, _functional.styleToNumber)(_marginTop);
      }

      return offset;
    }
  }]);
  return ScrollTo;
}();

exports.default = ScrollTo;